import dayjs from '@utils/libraries/dayjs'
import { useUser } from 'src/store/modules/App/user'

/**
 * Function to return the date in a specific format 'L LT' which is the localized form of 'DD/MM/YYYY HH:mm A'
 * @param  {String} value date in the current timezone
 * @param  {String} format default separator of the date is 'L LT'
 * @param {String} timezone default timezone is the user current timezone
 * @param {Boolean} withoutTimeZone used to return date without adding a timezone
 * @return {String}
 */
export const formatDate = (
  value: string | number | Date | dayjs.Dayjs | null | undefined,
  format: string = 'L LT',
  timezone?: string,
  withoutTimeZone = false,
): string => {
  const userStore = useUser()

  const userLanguage = userStore?.language || 'en'

  if (withoutTimeZone) {
    return dayjs(value).locale(userLanguage).format(format)
  }

  return dayjs(value)
    .locale(userLanguage)
    .tz(timezone || userStore?.user?.timezone || 'Europe/Vienna')
    .format(format)
}
